import { combineReducers } from 'redux'
import GeneralReducer from './GeneralReducer'
import TaskReducer from './TaskReducer'
import UserReducer from './UserReducer'
import TaskDetailsReducer from './TaskDetailsReducer'
import ModalReducer from './ModalReducer'
import NotificationReducer from './NotificationReducer'
import VehicleReducer from './VehicleReducer'

export default combineReducers({
  general: GeneralReducer,
  tasks: TaskReducer,
  user: UserReducer,
  taskDetails: TaskDetailsReducer,
  modal: ModalReducer,
  notifications: NotificationReducer,
  vehicles: VehicleReducer
})
